import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/* eslint-disable no-nested-ternary */

/* eslint-disable @typescript-eslint/no-explicit-any,no-undefined */
import React from "react";
import classNames from "classnames";
import { INTERNAL_USER_ONLY, defaultPropertiesOverride, defaultSortPropertiesOverride } from "../../constants";
import { getClassName, getTypeClassName, getCustomHeaderRenderer, getColNumberFromAccessor } from "../../utils";
import TailUp from "./Icons/TailUp";
import TailUpAndDown from "./Icons/TailUpAndDown";
import TailDown from "./Icons/TailDown";
import Filter from "./Icons/Filter";
import InternalIcon from "./Icons/InternalIcon";
export var TableHeader = function TableHeader(_ref) {
  var headerGroups = _ref.headerGroups,
      sorting = _ref.sorting,
      useDefaultColspan = _ref.useDefaultColspan,
      getHeaderProps = _ref.getHeaderProps,
      getColumnProps = _ref.getColumnProps,
      setShowFilterModalFun = _ref.setShowFilterModalFun;
  var rowClassName = getClassName({
    descendantName: "row",
    modifiers: "header"
  });
  var internalClassName = getClassName({
    descendantName: "internal"
  });
  var cellClassName = getClassName({
    descendantName: "cell",
    modifiers: "header"
  });
  var sortByClassName = getClassName({
    descendantName: "sortBy"
  });
  var sortByDirectionClassName = getClassName({
    descendantName: "sortByDirection"
  });
  var filterClassName = getClassName({
    descendantName: "filter"
  });
  var noSortingSelectedClassName = getClassName({
    descendantName: "noSortingSelected"
  });

  var getSortingAriaAttribute = function getSortingAriaAttribute(isSortingConfigured, isSortedDesc, isSortedAsc) {
    if (isSortingConfigured) {
      if (isSortedDesc) {
        return sorting === null || sorting === void 0 ? void 0 : sorting.ariaSortDescendingName;
      }

      if (isSortedAsc) {
        return sorting === null || sorting === void 0 ? void 0 : sorting.ariaSortAscendingName;
      }
    }

    return undefined;
  };

  var getHeaderCell = function getHeaderCell(header) {
    var Header = header.Header,
        accessor = header.accessor,
        type = header.type,
        sortingAriaLabel = header.sortingAriaLabel,
        sortable = header.sortable,
        isSortedDesc = header.isSortedDesc,
        style = header.style,
        className = header.className,
        renderHeaderLabel = header.renderHeaderLabel,
        filterable = header.filterable,
        internal = header.internal;
    var isSortingConfigured = sortable && Boolean(sorting) || filterable;
    var isDesc = isSortedDesc === true;
    var isAsc = isSortedDesc === false;
    var isSorted = isAsc || isDesc;

    var tableHeadProperties = _objectSpread(_objectSpread({}, defaultPropertiesOverride), !useDefaultColspan && {
      colSpan: null
    });

    if (accessor) {
      tableHeadProperties.scope = "col";
      tableHeadProperties["aria-sort"] = getSortingAriaAttribute(isSortingConfigured, isDesc, isAsc);
    }

    var renderSortableHeader = function renderSortableHeader() {
      var sortableButtonProps = header.getHeaderProps(header.getSortByToggleProps());
      var defaultHeaderLabel = /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "sortByText",
          modifiers: isSorted ? "sorted" : null
        })
      }, header.render("Header"));
      var configuredHeaderLabel = (renderHeaderLabel === null || renderHeaderLabel === void 0 ? void 0 : renderHeaderLabel(defaultHeaderLabel)) || defaultHeaderLabel;
      return /*#__PURE__*/React.createElement("div", {
        className: sortByClassName
      }, configuredHeaderLabel, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "actionButtons"
        })
      }, /*#__PURE__*/React.createElement("div", null, sortable && (isSorted ? isDesc ? /*#__PURE__*/React.createElement("button", _extends({}, sortableButtonProps, defaultSortPropertiesOverride, {
        "aria-label": "Sorted Descending",
        className: sortByDirectionClassName
      }), TailUp) : /*#__PURE__*/React.createElement("button", _extends({}, sortableButtonProps, defaultSortPropertiesOverride, {
        "aria-label": "Sorted Ascending",
        className: sortByDirectionClassName
      }), TailDown) : /*#__PURE__*/React.createElement("button", _extends({}, sortableButtonProps, defaultSortPropertiesOverride, {
        "aria-label": "Sort",
        className: noSortingSelectedClassName
      }), TailUpAndDown))), /*#__PURE__*/React.createElement("div", null, filterable && /*#__PURE__*/React.createElement("button", {
        "aria-label": "Show Filters",
        className: filterClassName,
        onClick: function onClick(e) {
          return setShowFilterModalFun && setShowFilterModalFun(e, getColNumberFromAccessor(header.id));
        }
      }, Filter))));
    };

    var rendererHeader = function rendererHeader() {
      if (typeof Header === "function") {
        return header.render(getCustomHeaderRenderer(Header, isSortingConfigured, sortingAriaLabel));
      }

      if (isSortingConfigured) {
        return renderSortableHeader();
      }

      return header.render("Header");
    };

    var rendererInternalHeader = function rendererInternalHeader() {
      return /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "internalHeader"
        })
      }, /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "internalIcon"
        })
      }, InternalIcon), rendererHeader(), /*#__PURE__*/React.createElement("div", {
        className: getClassName({
          descendantName: "tooltip"
        })
      }, /*#__PURE__*/React.createElement("span", {
        className: getClassName({
          descendantName: "tooltipText"
        })
      }, INTERNAL_USER_ONLY)));
    };

    return /*#__PURE__*/React.createElement("th", _extends({}, header.getHeaderProps([tableHeadProperties, (getColumnProps === null || getColumnProps === void 0 ? void 0 : getColumnProps(header)) || {}, (getHeaderProps === null || getHeaderProps === void 0 ? void 0 : getHeaderProps(header)) || {}]), {
      style: style,
      className: classNames(className, getTypeClassName(type), cellClassName, internal && internalClassName)
    }), internal ? rendererInternalHeader() : rendererHeader());
  };

  var getHeaderRow = function getHeaderRow(headerGroup) {
    var rowProps = headerGroup.getHeaderGroupProps([defaultPropertiesOverride]);
    return /*#__PURE__*/React.createElement("tr", _extends({}, rowProps, {
      className: rowClassName
    }), headerGroup.headers.map(getHeaderCell));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, headerGroups.map(getHeaderRow));
};